import {Component, Input, OnInit} from '@angular/core';
import {ProceduresService} from '../../services/procedures.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import FileManager from '../../interfaces/FileManager';
import DocumentFile from '../../interfaces/DocumentFile';
import {finalize} from 'rxjs/operators';
import {FirebaseStorageService} from '../../services/firebase-storage.service';
import * as moment from 'moment';
import {ShowPreviewFilesComponent} from '../../utils/show-preview-files/show-preview-files.component';
import {NbDialogService} from '@nebular/theme';

@Component({
  selector: 'ngx-file-manager',
  templateUrl: './file-manager.component.html',
  styleUrls: ['./file-manager.component.scss'],
})
export class FileManagerComponent implements OnInit {
  @Input() station_id: string;
  @Input() fileManager: FileManager;
  loading = false;
  uploadPercentage: any = 0;
  moment = moment;

  constructor(
    private firebaseStorageService: FirebaseStorageService,
    private procedureService: ProceduresService,
    private dialog: NbDialogService,
  ) { }

  ngOnInit() { }

  async uploadFile() {
    return Swal.fire({
      title: 'Adjuntar archivo',
      input: 'file',
      inputAttributes: { autocapitalize: 'off' },
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      showLoaderOnConfirm: true,
      preConfirm: async (file) => (file) ? this.upload(file) : null,
      allowOutsideClick: () => !Swal.isLoading(),
    });
  }

  async upload(file: File) {
    this.loading = true;
    await this.firebaseStorageService.setPath(this.fileManager.uploadPath);
    const filename = `${this.fileManager.id}_${file.name}`;
    const fileRef = await this.firebaseStorageService.referenceCloudStorage(filename);
    const task = this.firebaseStorageService.taskCloudStorage(filename, file);
    // observe percentage changes
    task.percentageChanges().subscribe((porcentaje) => this.uploadPercentage = Math.round(porcentaje));
    // get notified when the download URL is available
    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe(async (url) => {
          const data: DocumentFile = {
            station_id: this.station_id,
            url,
            name: file.name,
            size: file.size,
            type: file.type,
            documentable_id: this.fileManager.id,
            documentable_type: this.fileManager.type,
          };
          const [error] = await this.procedureService.storeDocument(data);
          this.uploadPercentage = 0;
          this.loading = false;
          if (error) return this.alert('Oops, ocurrio un error al cargar el archivo', 'error');
          this.fileManager.documents.push(data);
          await this.alert('Se cargo el fichero con exito', 'success');
        });
      }),
    ).subscribe();

  }

  openFile(url) {
    this.dialog.open(ShowPreviewFilesComponent, {
      hasScroll: true,
      context: { url },
    });
  }

  editDocument(document: DocumentFile) {}

  async deleteDocument(document: DocumentFile) {
    this.loading = true;
    await this.procedureService.deleteFileByUrl(document.url);
    const [error] = await this.procedureService.deleteDocument(document.id);
    this.loading = false;
    if (error) return this.alert('Oops, ocurrio un error al eliminar el archivo', 'error');
    this.fileManager.documents = this.fileManager.documents.filter((documentAux: DocumentFile) => documentAux.id !== document.id);
    await this.alert('Éxito', 'success', 'Se elimino el archivo');
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    return Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
